import { Helmet } from "react-helmet";

export const SEOHead = () => {
  const title = "Sky Lofi ATC - Lofi Beats + Live ATC Radio for Focus";
  const description = "Free 24/7 lofi hip hop mixed with live air traffic control radio. Perfect study music for coding, work & relaxation.";
  const url = "https://skylofiatc.com/";
  const image = "https://skylofiatc.com/og-image.jpg";

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content="lofi, lofi hip hop, ATC radio, air traffic control, study music, focus music, chill beats, ambient music, coding music, work music" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Sky Lofi ATC" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="Sky Lofi ATC" />
      <meta name="theme-color" content="#1a1f2e" />
    </Helmet>
  );
};
